import fetcher_v2 from "@/api/fetcher_v2";
import { URLS } from "@/api/urls";
import { FeatureType } from "@/features";

type FeaturesMap = Partial<Record<FeatureType, boolean>>;

export type UserAndOrganizationFeatures = {
  organization: FeaturesMap;
  user: FeaturesMap;
};

export const getFeatures = () => {
  return fetcher_v2<UserAndOrganizationFeatures>(URLS.FEATURES);
};
